/**
 * Represents the current state of a store's data synchronization
 */
export var StoreStatus;
(function (StoreStatus) {
    /**
     * Initial state when the store is created but no data has been loaded yet
     * This is the default state for new stores
     */
    StoreStatus["INITIAL"] = "INITIAL";
    /**
     * Store is currently fetching data from the server for the first time
     * No cached data is available
     */
    StoreStatus["LOADING"] = "LOADING";
    /**
     * Store has cached data and is fetching updates from the server
     * The cached data is still being used while the update is in progress
     */
    StoreStatus["UPDATING"] = "UPDATING";
    /**
     * New data is available from the server and has been cached
     * The store needs to be refreshed to show the latest data
     */
    StoreStatus["UPDATE_AVAILABLE"] = "UPDATE_AVAILABLE";
    /**
     * Store has the latest data from the server
     * All cached data is up to date
     */
    StoreStatus["UP_TO_DATE"] = "UP_TO_DATE";
})(StoreStatus || (StoreStatus = {}));
export var ErrorStatus;
(function (ErrorStatus) {
    ErrorStatus[ErrorStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    ErrorStatus[ErrorStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    ErrorStatus[ErrorStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
})(ErrorStatus || (ErrorStatus = {}));
/**
 * Class representing the status of a store
 * Used to track loading states and prevent race conditions in data synchronization
 */
export class StoreStatusState {
    constructor() {
        this.status = StoreStatus.INITIAL;
        this.error = null;
        this.id = null;
    }
    /**
     * Checks if an update should be applied to the store based on the entity ID
     * This prevents race conditions when multiple entities are being loaded
     *
     * @param updateId - The ID of the entity being updated
     * @returns boolean indicating whether the update should be applied
     */
    shouldApplyUpdate(updateId) {
        // Only apply the update if it's for the currently loaded entity
        return this.id === updateId;
    }
    /**
     * Sets the status and ID of the store
     *
     * @param newId - The UUID of the entity being loaded
     * @param newStatus - The new status of the store
     */
    setStatus(newId, newStatus) {
        this.id = newId;
        this.status = newStatus;
    }
    setError(newId, newState) {
        this.id = newId;
        this.error = newState;
    }
    /**
     * Resets the store status to initial state
     */
    reset() {
        this.status = StoreStatus.INITIAL;
        this.error = null;
        this.id = null;
    }
}
